import { Aggregator, ChainId } from "@ashswap/ash-sdk-js";

export const AshswapAggregator = new Aggregator({
  chainId: ChainId.Mainnet,
});
